/**=========================================================
 * Module: qa.js
 * Qa Controller
 =========================================================*/

 App.controller('QaController',
 ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService',
  'Restangular', 'DataService', 'ngDialog', '$filter', 'toaster',
 function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, ngDialog, $filter, toaster) {
   "use strict";

    $scope.page = {
      title: 'labels.QASTATS'
    };

    var startingDate = new Date(2018, 0, 1);

    $scope.model = {
      type:'qa'
    }
    $scope.showResults = false;
    $scope.suppliersById = {};
    
    D.query('group','type=SUPPLIER', { cache: false }).then(
      function(response){
          $scope.suppliers = response;
          for(var i=0; i<$scope.suppliers.length; i++){
            $scope.suppliersById[$scope.suppliers[i].id] = $scope.suppliers[i]; 
          }

          $scope.form = {
            title: '',
            status: '',
            type: 'stat',
            model: $scope.model,
            fields: [
              {
                available: true,
                type: 'checkboxes',
                name: 'suppliers',
                data: $scope.suppliers,
                valueField: 'id',
                labelField: 'name',
                required: true
              },{
                available: true,
                type: 'select',
                name: 'admin',
                placeholder: 'labels.ALL',
                valueField: 'id',
                labelField: 'name',
                data: $rootScope.admins,
                label: 'fields.LANGUAGEANALYST'
            },
            {
                available: true,
                type: 'select',
                name: 'client',
                placeholder: 'labels.ALL',
                valueField: 'id',
                labelField: 'name',
                data: $rootScope.clients,
                label: 'fields.CLIENT'
            },{
                available: true,
                type: 'date',
                name: 'from',
                minDate: startingDate
              },{
                available: true,
                type: 'date',
                name: 'to',
                minDate: startingDate
              },{
                available: true,
                type: 'submit'
              }
            ],
            submit: function(){
              if(!$scope.model.from) $scope.model.from = startingDate.getTime();
              $scope.form.status = 'submitting'
              $scope.showResults = false;
              D.save('stat', $scope.model).then(function(response){
                var statId = response.id;
                waitForStat(statId);
              }).catch(console.error);
            }
          }
      }).catch(console.error);

    $scope.showRows = {};
    var waitForStat = function(id){
      D.load('stat', id).then(function(response){
        if(response && response.result){
          $scope.form.status = '';
          $scope.stat = response.result;
          $scope.statArray = [];
          for(var key in $scope.stat){
            $scope.stat[key].qaprojects = (($scope.stat[key].qaerrors || 0) / ($scope.stat[key].projects || 1));
            $scope.stat[key].qacombinations = (($scope.stat[key].qaerrors || 0) / ($scope.stat[key].combinations || 1));
            $scope.statArray.push({key:key,value:$scope.stat[key]});
          }
          $scope.statArray = $scope.statArray.sort(function(a,b){
            return a.value.qacombinations > b.value.qacombinations;
          });
          $scope.projectsData = response.result.projectsData;
          $scope.showResults = true;
        } else {
          $timeout(function(){waitForStat(id);}, 5000);
        }
      }).catch(function(err){
        $timeout(function(){waitForStat(id);}, 5000);
      });
    }

    $scope.openProjectsData = function(){
    	var scope = $scope.$new();
	    scope.data = $scope.projectsData;
        scope.table = {
            title: '',
            filter: false,
            fields: [
                {
                    available: true,
                    hasLink: true,
                    name: 'code',
                    label: 'PROJECTCODE'
                },{
                    available: true,
                    name: 'name'
                },{
                    available: false && $rootScope.user.groupType!='CLIENT',
                    name: 'client'
                },{
                    available: true,
                    name: 'createdOn',
                    label: 'DATE',
                    type: 'date',
                    def: '-'
                },{
                    available: true,
                    name: 'source',
                    type: 'enum',
                    enumType: 'language'
                },{
                    available: true,
                    name: 'destinations',
                    type: 'enumSet',
                    enumType: 'language'
                },{
                    available: true,
                    name: 'supplier',
                    label: 'CHOSENSUPPLIER'
                },{
                    available: false,
                    name: 'referent'
                },{
                    available: false,
                    name: 'totalWords'
                },{
                    available: false,
                    name: 'normalizedWords'
                },{
                    available: false,
                    name: 'recoveredWords'
                }
            ],
            link: {
                state: 'app.do',
                action: 'open',
                type: 'project',
                filter: 'id'
            }
        };
	    ngDialog.open({
	      template: '/app/views/entities/stats-projectsdata.html',
	      className: 'ngdialog-theme-large',
	      scope: scope,
	      cache: false
        });

    };

 }]);
